export interface DadosUsuario {
  guid: string;
  codPosto: number;
  dsclogin?: string;
  dscemail?: string;
  dsctelefone?: string;
  tipo: number;
}

export interface AlteracaoCombustivel extends DadosUsuario {
  combustivel: Combustivel;
}

export interface Combustivel {
  indCombustivel: string;
  precoPrazo: PrecoPrazo;
  precoUnitario: PrecoUnitario;
  precoRedeEspecial: precoRedeEspecialSend | null;
  descontoPercentual: DescontoPercentual;
  descontoCentavos: DescontoCentavos;
  precoAnterior: PrecoAnterior;
  precoNovo: PrecoNovo;
  precoNegociado: PrecoNegociado;
  descricaoCombustivel: string;
  disponivelParaVenda: number;
}

export interface PrecoPrazo {
  valor: number;
  descricao: string;
}

export interface PrecoUnitario {
  valor: number;
  descricao: string;
}

export interface DescontoPercentual {
  valor: number;
  descricao: string;
}

export interface DescontoCentavos {
  valor: number;
  descricao: string;
}

export interface PrecoAnterior {
  valor: number;
  descricao: string;
}

export interface PrecoNovo {
  valor: number;
  descricao: string;
}

export interface PrecoNegociado {
  valor: number;
  descricao: string;
}

export interface precoRedeEspecialSend {
  valor: number;
  descricao: string;
}

export interface NomeCombustivel {
  codigoCombustivel: number;
  combustivel: string;
  descricaoCombustivel: string;
}

export interface INomeCombustivel {
  retorno: NomeCombustivel[];
  sucesso: boolean;
  mensagens: string[];
}
